export default __webpack_public_path__ + "static/media/apps-bulletinboard.54e2ea43.svg";